import { useForm, Controller } from "react-hook-form";
import Input from "../Input/Input";
import InputForm from "../InputForm/InputForm";
import InputFormHeading from "../InputForm/InputFormHeading";
import TextButton from "../Button/TextButton/TextButton";
import PhoneInput from "react-phone-input-2";
import { useEffect, useState } from "react";
import { fetchLocalities, fetchStates } from "../../services/userServices";
import Select from "react-select";
import OTPInput from "react-otp-input";
import { Step, Stepper } from "react-form-stepper";
import { useDispatch, useSelector } from "react-redux";
import { signupUser, verfiyOtpCode } from "../../store/user/userActions";
import cogoToast from "cogo-toast";
import {
  selectConfirmStart,
  selectSingupError,
  selectSingupStart,
} from "../../store/user/userSelector";

const SignupForm = () => {
  const state = useSelector((state) => state);
  let signupError = selectSingupError(state);
  let singupStart = selectSingupStart(state);
  let confirmStart = selectConfirmStart(state);
  const [sudanStates, setSudanStates] = useState([]);
  const [sudanLocalities, setSudanLocalities] = useState([]);
  const [activeStep, setActiveStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [hiddenOtp, setHiddenOtp] = useState("");
  const [registerInfos, setRegisterInfos] = useState([]);
  const [agreePolicy, setAgreePolicy] = useState(false);

  const dispatch = useDispatch();
  const verifyOtp = () => {
    if (registerInfos?.email && otp) {
      if (atob(hiddenOtp) == otp) {
        const registerObj = {
          email: registerInfos.email,
          otp: otp,
        };
        dispatch(
          verfiyOtpCode(registerObj, () => {
            cogoToast.success("تم انشاء الحساب بنجاح");
          })
        );
      } else {
        cogoToast.error("الرجاء التأكد من رمز التحقق");
      }
    }
  };

  const {
    register,
    control,
    formState: { errors, isSubmitting },
    handleSubmit,
    watch,
  } = useForm();

  const onSubmit = async (data) => {
    if (!sudanLocalities.some(locality => locality.value === data.locality?.value)) {
      cogoToast.error('الرجاء اختيار محلية من نفس الولاية')
      return;
    }
    if(!agreePolicy)
    {
      cogoToast.info('يجب عليك الموافقة على شروط الاستخدام حتى تقوم بإنشاء حساب');
      return;
    }
    const allData = {
      ...data,
      state_id: data?.state?.value,
      locality_id: data?.locality?.value,
    };

    const { state, locality, password_confirm, ...registerProfile } = allData;
    setRegisterInfos(registerProfile);

    await dispatch(
      signupUser(registerProfile, (value) => {
        setActiveStep(activeStep + 1);
        setHiddenOtp(value.user.co);
      })
    );
  };

  useEffect(() => {
    if (signupError) {
      cogoToast.error(signupError, { hideAfter: 5000 });
    }
  }, [signupError]);

  useEffect(() => {
    fetchStates().then((data) => {
      setSudanStates(
        data.map((el) => {
          return {
            value: el.id,
            label: el.name,
          };
        })
      );
      fetchLocalities(data[0].id).then((res) => {
        setSudanLocalities(
          res.map((el) => {
            return {
              value: el.id,
              label: el.name,
            };
          })
        );
      });
    });
  }, []);

  const handleStateChange = (stateID) => {
    fetchLocalities(stateID).then((res) => {
      setSudanLocalities(
        res.map((el) => {
          return {
            value: el.id,
            label: el.name,
          };
        })
      );
    });
  };

  const renderPrimaryDataStep = () => (
    <>
      <div className="input-wrap">
        <input
          type="text"
          className="input"
          style={{ textAlign: "right" }}
          {...register("full_name", { required: true })}
        />
        <label className="input-label">الاسم</label>
      </div>
      {errors?.full_name?.type === "required" && (
        <p className="error-text">يرجى ملئ هذا الحقل</p>
      )}
      <div className="input-wrap">
        <input
          type="text"
          className="input"
          style={{ textAlign: "right" }}
          {...register("father_name", { required: true })}
        />
        <label className="input-label">الأب</label>
      </div>
      {errors?.father_name?.type === "required" && (
        <p className="error-text">يرجى ملئ هذا الحقل</p>
      )}
      <div className="input-wrap">
        <input
          type="text"
          className="input"
          style={{ textAlign: "right" }}
          {...register("grand_father_name", { required: true })}
        />
        <label className="input-label">الجد</label>
      </div>
      {errors?.grand_father_name?.type === "required" && (
        <p className="error-text">يرجى ملئ هذا الحقل</p>
      )}
      <div className="input-wrap">
        <input
          type="email"
          className="input"
          style={{ textAlign: "right" }}
          {...register("email", {
            required: true,
            pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          })}
        />
        <label className="input-label">البريد الالكتروني</label>
      </div>
      {errors?.email?.type === "required" && (
        <p className="error-text" style={{ paddingBottom: "1rem" }}>
          يرجى ملئ هذا الحقل
        </p>
      )}
      {errors?.email?.type === "pattern" && (
        <p className="error-text" style={{ paddingBottom: "1rem" }}>
          البريد الالكتروني غير صحيح
        </p>
      )}
      <Controller
        control={control}
        name="phone"
        rules={{ required: true }}
        render={({ field }) => (
          <PhoneInput
            country={"sd"}
            // value={registerProfile.phone}
            // onChange={(e) => handleData("phone", e)}
            className="w-100"
            style={{ marginBottom: "1rem" }}
            {...field}
            inputExtraProps={{
              required: true,
              autoFocus: true,
            }}
          />
        )}
      />
      {errors?.phone?.type === "required" && (
        <p className="error-text">يرجى ملئ هذا الحقل</p>
      )}

      <div className="input-wrap">
        <input
          type="password"
          className="input"
          style={{ textAlign: "right" }}
          {...register("password", {
            required: true,
            minLength: 8,
            maxLength: 30,
          })}
        />
        <label className="input-label">كلمة السر</label>
      </div>
      {errors?.password?.type === "required" && (
        <p className="error-text">يرجى ملئ هذا الحقل</p>
      )}
      {errors?.password?.type === "minLength" && (
        <p className="error-text">
          يجب أن تحتوي كلمة المرور على 8 محارف على الأقل
        </p>
      )}
      {errors?.password?.type === "maxLength" && (
        <p className="error-text">
          يجب أن تحتوي كلمة المرور على 30 محرف على الأكثر
        </p>
      )}
      <div className="input-wrap">
        <input
          type="password"
          className="input"
          style={{ textAlign: "right" }}
          {...register("password_confirm", {
            required: true,
            validate: (val) => {
              if (watch("password") != val) {
                return "Your passwords do no match";
              }
            },
          })}
        />
        <label className="input-label">تأكيد كلمة السر</label>
      </div>
      {errors?.password_confirm?.type === "required" && (
        <p className="error-text">يرجى ملئ هذا الحقل</p>
      )}
      {errors?.password_confirm?.type === "validate" && (
        <p className="error-text">كلمات المرور غير متطابقة</p>
      )}
      <div className="input-wrap">
        <input
          type="text"
          className="input"
          style={{ textAlign: "right" }}
          {...register("work", { required: true })}
        />
        <label className="input-label">العمل</label>
      </div>
      {errors?.work?.type === "required" && (
        <p className="error-text">يرجى ملئ هذا الحقل</p>
      )}

      <div className="input-wrap">
        <input
          type="date"
          className="input"
          style={{ textAlign: "right" }}
          {...register("dob", { required: true })}
        />
        <label className="input-label">تاريخ الميلاد</label>
      </div>
      {errors?.dob?.type === "required" && (
        <p className="error-text">يرجى ملئ هذا لحقل</p>
      )}

      <div className="my-4 gender-wrapper">
        <div className="gender-div">
          <div>الجنس</div>
          <div>
            <label htmlFor="male-gender">ذكر</label>
            <input
              type="radio"
              id="male-gender"
              value="male"
              name="gender"
              {...register("gender", { required: true })}
            />
            <label htmlFor="female-gender">أنثى</label>
            <input
              type="radio"
              id="female-gender"
              value="female"
              name="gender"
              {...register("gender", { required: true })}
            />
          </div>
        </div>
      </div>
      {errors?.gender?.type === "required" && (
        <p className="error-text">يرجى ملئ هذا لحقل</p>
      )}

      <div className="input-wrap">
        <input
          type="text"
          className="input"
          style={{ textAlign: "right" }}
          {...register("city", { required: true })}
        />
        <label className="input-label">المدينة</label>
      </div>
      {errors?.city?.type === "required" && (
        <p className="error-text">يرجى ملئ هذا لحقل</p>
      )}

      <Controller
        control={control}
        name="state"
        defaultValue={null}
        rules={{ required: true }}
        render={({ field }) => (
          <Select
            {...field}
            styles={{
              control: (styles) => ({
                ...styles,
                backgroundColor: "#010724",
                color: "#fff",
              }),
              option: (styles) => ({
                ...styles,
                backgroundColor: "#010724",
                color: "#fff",
                border: "#fff solid",
                cursor: "pointer",
                ":active": {
                  ...styles[":active"],
                  color: "#fff",
                },
              }),
            }}
            placeholder="الولاية"
            className="basic-single my-4"
            classNamePrefix="select"
            isClearable={true}
            isRtl={true}
            isSearchable={true}
            options={sudanStates}
            onChange={(selectedOption) => {
              field.onChange(selectedOption); // Preserve the original e value
              handleStateChange(selectedOption?.value);
            }}
          />
        )}
      />
      {errors?.state?.type === "required" && (
        <p className="error-text">يرجى ملئ هذا لحقل</p>
      )}

      <Controller
        control={control}
        name="locality"
        defaultValue={null}
        rules={{ required: true }}
        render={({ field }) => (
          <Select
            {...field}
            styles={{
              control: (styles) => ({
                ...styles,
                backgroundColor: "#010724",
                color: "#fff",
              }),
              option: (styles) => ({
                ...styles,
                backgroundColor: "#010724",
                color: "#fff",
                border: "#fff solid",
                cursor: "pointer",
                ":active": {
                  ...styles[":active"],
                  color: "#fff",
                },
              }),
            }}
            placeholder="المحلية"
            className="basic-single my-4"
            classNamePrefix="select"
            isClearable={true}
            isRtl={true}
            isSearchable={true}
            options={sudanLocalities}
          />
        )}
      />
      {errors?.locality?.type === "required" && (
        <p className="error-text">يرجى ملئ هذا لحقل</p>
      )}
      <div className="input-wrap">
        <input
          type="checkbox"
          checked={agreePolicy}
          onChange={(e) => setAgreePolicy(e.target.checked)}
        />
        <label className="input-label">أنا اوافق على شروط الاستخدام</label>
      </div>
      <div className="signup-form-submit-btn">
        <TextButton
          type="submit"
          bcBlue
          rounded
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          التالي
        </TextButton>
      </div>
    </>
  );

  const renderVerifyOtp = () => (
    <>
      <h4 style={{ color: "#fff" }} className="text-center">
        تم إرسال رقم التأكيد على البريد الإلكتروني الرجاء ادخال الرمز لتوثيق
        الحساب
      </h4>

      <div className="otp-wrapper">
        <OTPInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          className="otp-div"
          renderInput={(props) => <input className="mx-3 inp-otp" {...props} />}
        />
      </div>
      <div className="signup-form-submit-btn">
        {/* <TextButton
          type="submit"
          bcBlue
          rounded
          onClick={() => setActiveStep(activeStep - 1)}
        >
          السابق
        </TextButton> */}
        <TextButton
          type="submit"
          bcBlue
          rounded
          onClick={verifyOtp}
          disabled={otp.length < 6 || confirmStart}
          loading={confirmStart}
        >
          التوثيق
        </TextButton>
      </div>
    </>
  );

  return (
    <div className="signup-comp label-up">
      <div className="user-form signup-form">
        <InputForm onSubmit={handleSubmit(onSubmit)}>
          <InputFormHeading heading={"أنشئ حسابك"} />
          <Stepper style={{ color: "#fff" }} activeStep={activeStep}>
            <Step
              id="1"
              label="المعلومات"
              onClick={(e) => {
                e.preventDefault();
              }}
            />
            <Step
              id="2"
              label="تأكيد البريد الإلكتروني"
              onClick={(e) => {
                e.preventDefault();
              }}
            />
          </Stepper>
          {activeStep === 1 && renderPrimaryDataStep()}
        </InputForm>
        {activeStep === 2 && renderVerifyOtp()}
      </div>
    </div>
  );
};

export default SignupForm;
